const getTooltip = () => {
  return {
    backgroundColor: '#F2F2F3',
    usePointStyle: true,
    boxWidth: 8,
    boxHeight: 8,
    boxPadding: 2,
    bodyFont: {
      size: 12.15
    },
    callbacks: {
      title: () => {
        return '';
      },
      label: (context: any) => {
        const label = context.dataset.label || context.label;
        let text = label[0].toUpperCase() + label.slice(1);
        const value = isNaN(context.raw) ? context.raw.label : (Number.isInteger(context.raw) ? context.raw : context.raw.toFixed(2));
        return `${text} - ${value}`;
      },
      labelTextColor: () => {
        return '#A8AAAE';
      },
      labelColor: (context: any) => {
        const color = context.dataset.color || (Array.isArray(context.dataset.backgroundColor) ? context.dataset.backgroundColor[context.dataIndex] : context.dataset.backgroundColor);
        return { 
          borderWidth: 0,
          backgroundColor: color,
          borderColor: color
        };
      },
      labelPointStyle: () => {
        return { pointStyle: 'circle', rotation: 0, pointBorderWidth: 0 };
      }
    }
  }
}

export { getTooltip };